import React from 'react';

import SeatMapRowsAndSeats from './seatMapRowsAndSeats';

export default class SeatMapState extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      hasReset: false,
      rowCenteredOnMap: false,
      sectionClicked: true,
      seatClickedFromMap: false,
      GASectionIdClickedFromList: null,
      rowClickedFromList: null,
      usidsOfListingSelected: null,
      hoveredSections: [],
    };
  }

  setLoadedState = (value) => {
    this.setState({loaded: value});
  };

  setHasResetState = (value) => {
    this.setState({hasReset: value});
  };

  setRowCenteredOnMapState = (value) => {
    this.setState({rowCenteredOnMap: value});
  };

  setStateFromObject = (obj) => {
    const existingState = Object.keys(this.state);
    const stateKeys = Object.keys(this.state);

    const badKey = existingState.find((key) => !stateKeys.includes(key));

    if (badKey) {
      throw new Error(`${badKey} is not part of the state object`);
    }

    this.setState(obj);
  };

  render() {
    return (
      <SeatMapRowsAndSeats
        {...this.props}
        {...this.state}
        setLoadedState={this.setLoadedState}
        setHasResetState={this.setHasResetState}
        setRowCenteredOnMapState={this.setRowCenteredOnMapState}
        setStateFromObject={this.setStateFromObject}
      />
    );
  }
}
